
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Baseservice } from './baseservice';
import { AuthenticationService } from './authentication.service';

import { HttpClient } from '@angular/common/http';

@Injectable()
export class  PermitTypeService extends Baseservice {

  constructor(http: HttpClient, authentication: AuthenticationService) {
    super('permit-type', http, authentication);
  }
  
  get() {
    return this.getPermitType(this.url);
  } 
setTerm(data){
return data;
}
  getPermitType(url: string) {
    return this.getRequest(url).pipe(map(response => response));
  }
  getByType(type: string) {
    return this.getRequest(this.url + '/bytype/' + type);
}
//permit/documentpermit/document/links/

getLinkedAndUnlinkedDoctypes(id: number) {
    return this.getRequest(this.url + '/document/links/' + id);
}

addToLinks(body: any) {

return this.http.post(this.url + '/document/links/', body);
}

deleteLink(id: number) {
    return this.http.delete(this.url + '/document/links/' + id);
}

updateLink(body: any) {

   return this.http.put(this.url + '/document/links/', body);
}

getLinkById(id: number) {
    return this.getRequest(this.url + `/document/links/find/${id}`);
}
getDocTypeLinkByCarrierTypeId(id: number) {
    return this.getRequest(this.url + `/document/links/type/${id}`);
}
getAllFixed(page, pageSize) {
    return this.getRequest(this.url + '/' + page + '/' + pageSize);
}


}
